import { Document } from '@app/types/document';
import { getDocumentDownloadLink } from '@app/page-fragments/dashboard/documents/components/DocumentDownloadLink';
import { getFormattedMessage } from '@app/components/formatted-message/FormattedMessage';
import { ONE_MB } from './file';
import { TableColumn, TableColumnsMap } from '@app/types/table';
import {
  documentDateTransformer,
  getDocumentActions,
  getFormattedCurrency,
  getDocumentStatus,
  documentUTCDateTransformer,
} from '@app/utils/document';

export const DEFAULT_DOCUMENT_TABLE_PAGE_SIZE = 10;

export const INSURANCE_DOC_UPLOAD_FILE_TYPES = ['pdf', 'jpg', 'jpeg', 'png'];

export const MAX_DRIVERS_LICENSE_SIZE_MB = 15 * ONE_MB;
export const MAX_DRIVERS_LICENSE_SIZE_MB_STRING = '15MB';

export const documentTableColumnsMap = {
  document: {
    id: 'document',
    label: getFormattedMessage({ data: { id: 'documents.headers.document' } }),
    dataKeys: ['original_file_name'],
  },
  coverageAmount: {
    id: 'coverageAmount',
    label: getFormattedMessage({ data: { id: 'documents.headers.coverageAmount' } }),
    dataKeys: ['extended_data', 'total_coverage_amount'],
    transformers: {
      data: getFormattedCurrency,
    },
  },
  validFrom: {
    id: 'validFrom',
    label: getFormattedMessage({ data: { id: 'documents.headers.validFrom' } }),
    dataKeys: ['valid_from'],
    transformers: {
      data: documentUTCDateTransformer,
    },
    isSortable: true,
  },
  expiration: {
    id: 'expiration',
    label: getFormattedMessage({ data: { id: 'documents.headers.expiration' } }),
    dataKeys: ['valid_until'],
    transformers: {
      data: documentUTCDateTransformer,
    },
    isSortable: true,
  },
  dateAdded: {
    id: 'dateAdded',
    label: getFormattedMessage({ data: { id: 'documents.headers.dateAdded' } }),
    dataKeys: ['date_created'],
    transformers: {
      data: documentDateTransformer,
    },
    isSortable: true,
    isDefaultSort: true,
  },
  status: {
    id: 'status',
    label: getFormattedMessage({ data: { id: 'documents.headers.status' } }),
    dataKeys: ['status_id'],
    transformers: {
      data: getDocumentStatus,
    },
  },
  actions: {
    id: 'actions',
    label: getFormattedMessage({ data: { id: 'documents.headers.actions' } }),
    transformers: {
      data: getDocumentActions,
    },
  },
} satisfies TableColumnsMap<Document>;

export const documentCompactTableColumnsMap = {
  ...documentTableColumnsMap,
  view: {
    id: 'view',
    label: getFormattedMessage({ data: { id: 'documents.headers.view' } }),
    transformers: {
      data: (data: Document) => getDocumentDownloadLink(data, 'view'),
    },
  },
} satisfies TableColumnsMap<Document>;

export const documentTableColumns: TableColumn<Document>[] = Object.values(documentTableColumnsMap);
export const documentCompactTableColumns: TableColumn<Document>[] = Object.values(
  documentCompactTableColumnsMap,
);
